import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AppButton from "../../common/AppButton";
import { CreateFeeStructureInput } from "./types/feeStructure";

interface FeeStructureFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (input: CreateFeeStructureInput) => void;
  loading?: boolean;
}

const FeeStructureForm: React.FC<FeeStructureFormProps> = ({
  open,
  onClose,
  onSubmit,
  loading
}) => {
  const { t } = useKivunovaTranslation();
  const [name, setName] = useState("");
  const [billingPeriodId, setBillingPeriodId] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  if (!open) {
    return null;
  }

  return (
    <Box
      data-testid="fee-structure-form"
      sx={{
        mb: 3,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("add-fee-structure", "Add fee structure")}
      </Typography>
      <Box sx={{ display: "grid", gap: 2, maxWidth: 480 }}>
        <TextField
          label={t("fee-name", "Fee name")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <TextField
          label={t("billing-period-id", "Billing period ID")}
          value={billingPeriodId}
          onChange={(e) => setBillingPeriodId(e.target.value)}
          required
          helperText={t(
            "billing-period-id-help",
            "Term or academic year ID from billing periods"
          )}
        />
        <TextField
          label={t("fee-amount", "Amount")}
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          required
        />
        <TextField
          label={t("fee-description", "Description")}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          minRows={2}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <AppButton
            disabled={loading || !name || !billingPeriodId || !amount}
            onClick={() =>
              onSubmit({
                name,
                billingPeriodId,
                amount: Number(amount),
                description: description || undefined
              })
            }
          >
            {t("save", "Save")}
          </AppButton>
          <AppButton variant="outlined" onClick={onClose}>
            {t("cancel", "Cancel")}
          </AppButton>
        </Box>
      </Box>
    </Box>
  );
};

export default FeeStructureForm;
